export { default } from './NumbersEdit.container'



// WEBPACK FOOTER //
// ./src/pages/NumbersEdit/index.js